// source: pbtypes/cloud/services/skygateway/device_stats.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_tools_cloud_api_data_level_pb = require('../../../../pbtypes/tools/cloud_api/data_level_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_data_level_pb);
var pbtypes_tools_cloud_api_enums_pb = require('../../../../pbtypes/tools/cloud_api/enums_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_enums_pb);
var pbtypes_gen_flight_connect_connection_state_pb = require('../../../../pbtypes/gen/flight_connect/connection_state_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_connection_state_pb);
var pbtypes_gen_flight_connect_transport_type_pb = require('../../../../pbtypes/gen/flight_connect/transport_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_transport_type_pb);
var pbtypes_gen_flight_connect_client_skybus_stats_pb = require('../../../../pbtypes/gen/flight_connect/client_skybus_stats_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_client_skybus_stats_pb);
var pbtypes_gen_flight_connect_video_stream_info_pb = require('../../../../pbtypes/gen/flight_connect/video_stream_info_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_video_stream_info_pb);
var pbtypes_gen_flight_connect_video_fusion_info_pb = require('../../../../pbtypes/gen/flight_connect/video_fusion_info_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_video_fusion_info_pb);
var pbtypes_gen_skybus_tunnel_fec_tunnel_stats_pb = require('../../../../pbtypes/gen/skybus_tunnel/fec_tunnel_stats_pb.js');
goog.object.extend(proto, pbtypes_gen_skybus_tunnel_fec_tunnel_stats_pb);
goog.exportSymbol('proto.skygateway.AggregateDeviceStats', null, global);
goog.exportSymbol('proto.skygateway.DeviceClientStats', null, global);
goog.exportSymbol('proto.skygateway.DeviceHeartbeat', null, global);
goog.exportSymbol('proto.skygateway.DeviceTunnelStats', null, global);
goog.exportSymbol('proto.skygateway.FecTunnelStats', null, global);
goog.exportSymbol('proto.skygateway.SkybusFilterChannel', null, global);
goog.exportSymbol('proto.skygateway.VideoFusionInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.FecTunnelStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.FecTunnelStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.FecTunnelStats.displayName = 'proto.skygateway.FecTunnelStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.DeviceTunnelStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.DeviceTunnelStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.DeviceTunnelStats.displayName = 'proto.skygateway.DeviceTunnelStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.SkybusFilterChannel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.SkybusFilterChannel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.SkybusFilterChannel.displayName = 'proto.skygateway.SkybusFilterChannel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.VideoFusionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skygateway.VideoFusionInfo.repeatedFields_, null);
};
goog.inherits(proto.skygateway.VideoFusionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.VideoFusionInfo.displayName = 'proto.skygateway.VideoFusionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.DeviceClientStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skygateway.DeviceClientStats.repeatedFields_, null);
};
goog.inherits(proto.skygateway.DeviceClientStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.DeviceClientStats.displayName = 'proto.skygateway.DeviceClientStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.AggregateDeviceStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skygateway.AggregateDeviceStats.repeatedFields_, null);
};
goog.inherits(proto.skygateway.AggregateDeviceStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.AggregateDeviceStats.displayName = 'proto.skygateway.AggregateDeviceStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skygateway.DeviceHeartbeat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skygateway.DeviceHeartbeat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skygateway.DeviceHeartbeat.displayName = 'proto.skygateway.DeviceHeartbeat';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.FecTunnelStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.FecTunnelStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.FecTunnelStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.FecTunnelStats.toObject = function(includeInstance, msg) {
  var f, obj = {
sampleCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
lastSeenUtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
sourceChunks: jspb.Message.getFieldWithDefault(msg, 3, 0),
recoveryChunks: jspb.Message.getFieldWithDefault(msg, 4, 0),
totalChunks: jspb.Message.getFieldWithDefault(msg, 5, 0),
droppedChunks: jspb.Message.getFieldWithDefault(msg, 6, 0),
unrecoveredFrames: jspb.Message.getFieldWithDefault(msg, 7, 0),
recoveredFrames: jspb.Message.getFieldWithDefault(msg, 8, 0),
totalFrames: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.FecTunnelStats}
 */
proto.skygateway.FecTunnelStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.FecTunnelStats;
  return proto.skygateway.FecTunnelStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.FecTunnelStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.FecTunnelStats}
 */
proto.skygateway.FecTunnelStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSampleCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLastSeenUtime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSourceChunks(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRecoveryChunks(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalChunks(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDroppedChunks(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnrecoveredFrames(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRecoveredFrames(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalFrames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.FecTunnelStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.FecTunnelStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.FecTunnelStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.FecTunnelStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSampleCount();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLastSeenUtime();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getSourceChunks();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getRecoveryChunks();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getTotalChunks();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getDroppedChunks();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getUnrecoveredFrames();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getRecoveredFrames();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getTotalFrames();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
};


/**
 * optional uint32 sample_count = 1;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getSampleCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setSampleCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 last_seen_utime = 2;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getLastSeenUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setLastSeenUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 source_chunks = 3;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getSourceChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setSourceChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 recovery_chunks = 4;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getRecoveryChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setRecoveryChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 total_chunks = 5;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getTotalChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setTotalChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 dropped_chunks = 6;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getDroppedChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setDroppedChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 unrecovered_frames = 7;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getUnrecoveredFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setUnrecoveredFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 recovered_frames = 8;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getRecoveredFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setRecoveredFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 total_frames = 9;
 * @return {number}
 */
proto.skygateway.FecTunnelStats.prototype.getTotalFrames = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.FecTunnelStats} returns this
 */
proto.skygateway.FecTunnelStats.prototype.setTotalFrames = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.DeviceTunnelStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.DeviceTunnelStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.DeviceTunnelStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DeviceTunnelStats.toObject = function(includeInstance, msg) {
  var f, obj = {
rxChunkCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
txChunkCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
rxByteCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
txByteCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
avgTxTimeMs: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
maxTxTimeMs: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
minTxTimeMs: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
totalTxTimeMs: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
rxDroppedEvents: jspb.Message.getFieldWithDefault(msg, 9, 0),
rxDroppedChunks: jspb.Message.getFieldWithDefault(msg, 10, 0),
fecChannelStatsMap: (f = msg.getFecChannelStatsMap()) ? f.toObject(includeInstance, proto.skygateway.FecTunnelStats.toObject) : [],
rxChannelStatsMap: (f = msg.getRxChannelStatsMap()) ? f.toObject(includeInstance, undefined) : [],
txChannelStatsMap: (f = msg.getTxChannelStatsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.DeviceTunnelStats}
 */
proto.skygateway.DeviceTunnelStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.DeviceTunnelStats;
  return proto.skygateway.DeviceTunnelStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.DeviceTunnelStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.DeviceTunnelStats}
 */
proto.skygateway.DeviceTunnelStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRxChunkCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTxChunkCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRxByteCount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTxByteCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgTxTimeMs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxTxTimeMs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinTxTimeMs(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalTxTimeMs(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRxDroppedEvents(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRxDroppedChunks(value);
      break;
    case 11:
      var value = msg.getFecChannelStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.skygateway.FecTunnelStats.deserializeBinaryFromReader, "", new proto.skygateway.FecTunnelStats());
         });
      break;
    case 12:
      var value = msg.getRxChannelStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 13:
      var value = msg.getTxChannelStatsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.DeviceTunnelStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.DeviceTunnelStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.DeviceTunnelStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DeviceTunnelStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRxChunkCount();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getTxChunkCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRxByteCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTxByteCount();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getAvgTxTimeMs();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMaxTxTimeMs();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMinTxTimeMs();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getTotalTxTimeMs();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getRxDroppedEvents();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getRxDroppedChunks();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getFecChannelStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getFecChannelStatsMap(true),
    11,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.skygateway.FecTunnelStats.serializeBinaryToWriter);
  }
  f = message.getRxChannelStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getRxChannelStatsMap(true),
    12,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getTxChannelStatsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getTxChannelStatsMap(true),
    13,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * optional uint32 rx_chunk_count = 1;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getRxChunkCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setRxChunkCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 tx_chunk_count = 2;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getTxChunkCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setTxChunkCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 rx_byte_count = 3;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getRxByteCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setRxByteCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 tx_byte_count = 4;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getTxByteCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setTxByteCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double avg_tx_time_ms = 5;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getAvgTxTimeMs = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setAvgTxTimeMs = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double max_tx_time_ms = 6;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getMaxTxTimeMs = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setMaxTxTimeMs = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double min_tx_time_ms = 7;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getMinTxTimeMs = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setMinTxTimeMs = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double total_tx_time_ms = 8;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getTotalTxTimeMs = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setTotalTxTimeMs = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional uint32 rx_dropped_events = 9;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getRxDroppedEvents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setRxDroppedEvents = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 rx_dropped_chunks = 10;
 * @return {number}
 */
proto.skygateway.DeviceTunnelStats.prototype.getRxDroppedChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.setRxDroppedChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * map<string, FecTunnelStats> fec_channel_stats = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.skygateway.FecTunnelStats>}
 */
proto.skygateway.DeviceTunnelStats.prototype.getFecChannelStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.skygateway.FecTunnelStats>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      proto.skygateway.FecTunnelStats));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.clearFecChannelStatsMap = function() {
  this.getFecChannelStatsMap().clear();
  return this;
};


/**
 * map<string, uint32> rx_channel_stats = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.DeviceTunnelStats.prototype.getRxChannelStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.clearRxChannelStatsMap = function() {
  this.getRxChannelStatsMap().clear();
  return this;
};


/**
 * map<string, uint32> tx_channel_stats = 13;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.DeviceTunnelStats.prototype.getTxChannelStatsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 13, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.DeviceTunnelStats} returns this
 */
proto.skygateway.DeviceTunnelStats.prototype.clearTxChannelStatsMap = function() {
  this.getTxChannelStatsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.SkybusFilterChannel.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.SkybusFilterChannel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.SkybusFilterChannel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.SkybusFilterChannel.toObject = function(includeInstance, msg) {
  var f, obj = {
filteredChannelsMap: (f = msg.getFilteredChannelsMap()) ? f.toObject(includeInstance, undefined) : [],
publishedChannelsMap: (f = msg.getPublishedChannelsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.SkybusFilterChannel}
 */
proto.skygateway.SkybusFilterChannel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.SkybusFilterChannel;
  return proto.skygateway.SkybusFilterChannel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.SkybusFilterChannel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.SkybusFilterChannel}
 */
proto.skygateway.SkybusFilterChannel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getFilteredChannelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    case 2:
      var value = msg.getPublishedChannelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readUint32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.SkybusFilterChannel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.SkybusFilterChannel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.SkybusFilterChannel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.SkybusFilterChannel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilteredChannelsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getFilteredChannelsMap(true),
    1,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
  f = message.getPublishedChannelsMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getPublishedChannelsMap(true),
    2,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeUint32);
  }
};


/**
 * map<string, uint32> filtered_channels = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.SkybusFilterChannel.prototype.getFilteredChannelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.SkybusFilterChannel} returns this
 */
proto.skygateway.SkybusFilterChannel.prototype.clearFilteredChannelsMap = function() {
  this.getFilteredChannelsMap().clear();
  return this;
};


/**
 * map<string, uint32> published_channels = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.skygateway.SkybusFilterChannel.prototype.getPublishedChannelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.SkybusFilterChannel} returns this
 */
proto.skygateway.SkybusFilterChannel.prototype.clearPublishedChannelsMap = function() {
  this.getPublishedChannelsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skygateway.VideoFusionInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.VideoFusionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.VideoFusionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.VideoFusionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.VideoFusionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
renderedFrameCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
avgOutputBitrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
avgOutputFramerate: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
selectedTransport: jspb.Message.getFieldWithDefault(msg, 4, 0),
streamInfoList: jspb.Message.toObjectList(msg.getStreamInfoList(),
    pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.VideoFusionInfo}
 */
proto.skygateway.VideoFusionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.VideoFusionInfo;
  return proto.skygateway.VideoFusionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.VideoFusionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.VideoFusionInfo}
 */
proto.skygateway.VideoFusionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRenderedFrameCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgOutputBitrate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvgOutputFramerate(value);
      break;
    case 4:
      var value = /** @type {!proto.flight_connect.TransportType.Enum} */ (reader.readEnum());
      msg.setSelectedTransport(value);
      break;
    case 5:
      var value = new pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo;
      reader.readMessage(value,pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.deserializeBinaryFromReader);
      msg.addStreamInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.VideoFusionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.VideoFusionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.VideoFusionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.VideoFusionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRenderedFrameCount();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAvgOutputBitrate();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getAvgOutputFramerate();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getSelectedTransport();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStreamInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 rendered_frame_count = 1;
 * @return {number}
 */
proto.skygateway.VideoFusionInfo.prototype.getRenderedFrameCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.VideoFusionInfo} returns this
 */
proto.skygateway.VideoFusionInfo.prototype.setRenderedFrameCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double avg_output_bitrate = 2;
 * @return {number}
 */
proto.skygateway.VideoFusionInfo.prototype.getAvgOutputBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.VideoFusionInfo} returns this
 */
proto.skygateway.VideoFusionInfo.prototype.setAvgOutputBitrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double avg_output_framerate = 3;
 * @return {number}
 */
proto.skygateway.VideoFusionInfo.prototype.getAvgOutputFramerate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.VideoFusionInfo} returns this
 */
proto.skygateway.VideoFusionInfo.prototype.setAvgOutputFramerate = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional flight_connect.TransportType.Enum selected_transport = 4;
 * @return {!proto.flight_connect.TransportType.Enum}
 */
proto.skygateway.VideoFusionInfo.prototype.getSelectedTransport = function() {
  return /** @type {!proto.flight_connect.TransportType.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.flight_connect.TransportType.Enum} value
 * @return {!proto.skygateway.VideoFusionInfo} returns this
 */
proto.skygateway.VideoFusionInfo.prototype.setSelectedTransport = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated flight_connect.VideoStreamInfo stream_info = 5;
 * @return {!Array<!proto.flight_connect.VideoStreamInfo>}
 */
proto.skygateway.VideoFusionInfo.prototype.getStreamInfoList = function() {
  return /** @type{!Array<!proto.flight_connect.VideoStreamInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo, 5));
};


/**
 * @param {!Array<!proto.flight_connect.VideoStreamInfo>} value
 * @return {!proto.skygateway.VideoFusionInfo} returns this
*/
proto.skygateway.VideoFusionInfo.prototype.setStreamInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.flight_connect.VideoStreamInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.VideoStreamInfo}
 */
proto.skygateway.VideoFusionInfo.prototype.addStreamInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.flight_connect.VideoStreamInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skygateway.VideoFusionInfo} returns this
 */
proto.skygateway.VideoFusionInfo.prototype.clearStreamInfoList = function() {
  return this.setStreamInfoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skygateway.DeviceClientStats.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.DeviceClientStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.DeviceClientStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.DeviceClientStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DeviceClientStats.toObject = function(includeInstance, msg) {
  var f, obj = {
streamInfoList: jspb.Message.toObjectList(msg.getStreamInfoList(),
    pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.toObject, includeInstance),
selectedStream: jspb.Message.getFieldWithDefault(msg, 2, 0),
skybusStats: (f = msg.getSkybusStats()) && pbtypes_gen_flight_connect_client_skybus_stats_pb.ClientSkybusStats.toObject(includeInstance, f),
fusionInfoMap: (f = msg.getFusionInfoMap()) ? f.toObject(includeInstance, proto.skygateway.VideoFusionInfo.toObject) : [],
globalToTunnelStats: (f = msg.getGlobalToTunnelStats()) && proto.skygateway.SkybusFilterChannel.toObject(includeInstance, f),
tunnelToGlobalStats: (f = msg.getTunnelToGlobalStats()) && proto.skygateway.SkybusFilterChannel.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.DeviceClientStats}
 */
proto.skygateway.DeviceClientStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.DeviceClientStats;
  return proto.skygateway.DeviceClientStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.DeviceClientStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.DeviceClientStats}
 */
proto.skygateway.DeviceClientStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo;
      reader.readMessage(value,pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.deserializeBinaryFromReader);
      msg.addStreamInfo(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_connect.TransportType.Enum} */ (reader.readEnum());
      msg.setSelectedStream(value);
      break;
    case 3:
      var value = new pbtypes_gen_flight_connect_client_skybus_stats_pb.ClientSkybusStats;
      reader.readMessage(value,pbtypes_gen_flight_connect_client_skybus_stats_pb.ClientSkybusStats.deserializeBinaryFromReader);
      msg.setSkybusStats(value);
      break;
    case 4:
      var value = msg.getFusionInfoMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readMessage, proto.skygateway.VideoFusionInfo.deserializeBinaryFromReader, "", new proto.skygateway.VideoFusionInfo());
         });
      break;
    case 5:
      var value = new proto.skygateway.SkybusFilterChannel;
      reader.readMessage(value,proto.skygateway.SkybusFilterChannel.deserializeBinaryFromReader);
      msg.setGlobalToTunnelStats(value);
      break;
    case 6:
      var value = new proto.skygateway.SkybusFilterChannel;
      reader.readMessage(value,proto.skygateway.SkybusFilterChannel.deserializeBinaryFromReader);
      msg.setTunnelToGlobalStats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.DeviceClientStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.DeviceClientStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.DeviceClientStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DeviceClientStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreamInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.serializeBinaryToWriter
    );
  }
  f = message.getSelectedStream();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSkybusStats();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_flight_connect_client_skybus_stats_pb.ClientSkybusStats.serializeBinaryToWriter
    );
  }
  f = message.getFusionInfoMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getFusionInfoMap(true),
    4,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeMessage,
    proto.skygateway.VideoFusionInfo.serializeBinaryToWriter);
  }
  f = message.getGlobalToTunnelStats();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.skygateway.SkybusFilterChannel.serializeBinaryToWriter
    );
  }
  f = message.getTunnelToGlobalStats();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.skygateway.SkybusFilterChannel.serializeBinaryToWriter
    );
  }
};


/**
 * repeated flight_connect.VideoStreamInfo stream_info = 1;
 * @return {!Array<!proto.flight_connect.VideoStreamInfo>}
 */
proto.skygateway.DeviceClientStats.prototype.getStreamInfoList = function() {
  return /** @type{!Array<!proto.flight_connect.VideoStreamInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo, 1));
};


/**
 * @param {!Array<!proto.flight_connect.VideoStreamInfo>} value
 * @return {!proto.skygateway.DeviceClientStats} returns this
*/
proto.skygateway.DeviceClientStats.prototype.setStreamInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.flight_connect.VideoStreamInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.VideoStreamInfo}
 */
proto.skygateway.DeviceClientStats.prototype.addStreamInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.flight_connect.VideoStreamInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skygateway.DeviceClientStats} returns this
 */
proto.skygateway.DeviceClientStats.prototype.clearStreamInfoList = function() {
  return this.setStreamInfoList([]);
};


/**
 * optional flight_connect.TransportType.Enum selected_stream = 2;
 * @return {!proto.flight_connect.TransportType.Enum}
 */
proto.skygateway.DeviceClientStats.prototype.getSelectedStream = function() {
  return /** @type {!proto.flight_connect.TransportType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_connect.TransportType.Enum} value
 * @return {!proto.skygateway.DeviceClientStats} returns this
 */
proto.skygateway.DeviceClientStats.prototype.setSelectedStream = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional flight_connect.ClientSkybusStats skybus_stats = 3;
 * @return {?proto.flight_connect.ClientSkybusStats}
 */
proto.skygateway.DeviceClientStats.prototype.getSkybusStats = function() {
  return /** @type{?proto.flight_connect.ClientSkybusStats} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_flight_connect_client_skybus_stats_pb.ClientSkybusStats, 3));
};


/**
 * @param {?proto.flight_connect.ClientSkybusStats|undefined} value
 * @return {!proto.skygateway.DeviceClientStats} returns this
*/
proto.skygateway.DeviceClientStats.prototype.setSkybusStats = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.DeviceClientStats} returns this
 */
proto.skygateway.DeviceClientStats.prototype.clearSkybusStats = function() {
  return this.setSkybusStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.DeviceClientStats.prototype.hasSkybusStats = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * map<string, VideoFusionInfo> fusion_info = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.skygateway.VideoFusionInfo>}
 */
proto.skygateway.DeviceClientStats.prototype.getFusionInfoMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.skygateway.VideoFusionInfo>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.skygateway.VideoFusionInfo));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.skygateway.DeviceClientStats} returns this
 */
proto.skygateway.DeviceClientStats.prototype.clearFusionInfoMap = function() {
  this.getFusionInfoMap().clear();
  return this;
};


/**
 * optional SkybusFilterChannel global_to_tunnel_stats = 5;
 * @return {?proto.skygateway.SkybusFilterChannel}
 */
proto.skygateway.DeviceClientStats.prototype.getGlobalToTunnelStats = function() {
  return /** @type{?proto.skygateway.SkybusFilterChannel} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.SkybusFilterChannel, 5));
};


/**
 * @param {?proto.skygateway.SkybusFilterChannel|undefined} value
 * @return {!proto.skygateway.DeviceClientStats} returns this
*/
proto.skygateway.DeviceClientStats.prototype.setGlobalToTunnelStats = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.DeviceClientStats} returns this
 */
proto.skygateway.DeviceClientStats.prototype.clearGlobalToTunnelStats = function() {
  return this.setGlobalToTunnelStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.DeviceClientStats.prototype.hasGlobalToTunnelStats = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional SkybusFilterChannel tunnel_to_global_stats = 6;
 * @return {?proto.skygateway.SkybusFilterChannel}
 */
proto.skygateway.DeviceClientStats.prototype.getTunnelToGlobalStats = function() {
  return /** @type{?proto.skygateway.SkybusFilterChannel} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.SkybusFilterChannel, 6));
};


/**
 * @param {?proto.skygateway.SkybusFilterChannel|undefined} value
 * @return {!proto.skygateway.DeviceClientStats} returns this
*/
proto.skygateway.DeviceClientStats.prototype.setTunnelToGlobalStats = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.DeviceClientStats} returns this
 */
proto.skygateway.DeviceClientStats.prototype.clearTunnelToGlobalStats = function() {
  return this.setTunnelToGlobalStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.DeviceClientStats.prototype.hasTunnelToGlobalStats = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skygateway.AggregateDeviceStats.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.AggregateDeviceStats.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.AggregateDeviceStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.AggregateDeviceStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AggregateDeviceStats.toObject = function(includeInstance, msg) {
  var f, obj = {
peerSerial: jspb.Message.getFieldWithDefault(msg, 1, ""),
avgRttMs: jspb.Message.getFieldWithDefault(msg, 2, 0),
connectionStatesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
clientStats: (f = msg.getClientStats()) && proto.skygateway.DeviceClientStats.toObject(includeInstance, f),
tunnelStats: (f = msg.getTunnelStats()) && proto.skygateway.DeviceTunnelStats.toObject(includeInstance, f),
sampleCount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.AggregateDeviceStats}
 */
proto.skygateway.AggregateDeviceStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.AggregateDeviceStats;
  return proto.skygateway.AggregateDeviceStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.AggregateDeviceStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.AggregateDeviceStats}
 */
proto.skygateway.AggregateDeviceStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPeerSerial(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAvgRttMs(value);
      break;
    case 3:
      reader.readPackableEnumInto(msg.getConnectionStatesList());
      break;
    case 4:
      var value = new proto.skygateway.DeviceClientStats;
      reader.readMessage(value,proto.skygateway.DeviceClientStats.deserializeBinaryFromReader);
      msg.setClientStats(value);
      break;
    case 5:
      var value = new proto.skygateway.DeviceTunnelStats;
      reader.readMessage(value,proto.skygateway.DeviceTunnelStats.deserializeBinaryFromReader);
      msg.setTunnelStats(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSampleCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.AggregateDeviceStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.AggregateDeviceStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.AggregateDeviceStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.AggregateDeviceStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeerSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvgRttMs();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getConnectionStatesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getClientStats();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.skygateway.DeviceClientStats.serializeBinaryToWriter
    );
  }
  f = message.getTunnelStats();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.skygateway.DeviceTunnelStats.serializeBinaryToWriter
    );
  }
  f = message.getSampleCount();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
};


/**
 * optional string peer_serial = 1;
 * @return {string}
 */
proto.skygateway.AggregateDeviceStats.prototype.getPeerSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.setPeerSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 avg_rtt_ms = 2;
 * @return {number}
 */
proto.skygateway.AggregateDeviceStats.prototype.getAvgRttMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.setAvgRttMs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated flight_connect.ConnectionState.Enum connection_states = 3;
 * @return {!Array<!proto.flight_connect.ConnectionState.Enum>}
 */
proto.skygateway.AggregateDeviceStats.prototype.getConnectionStatesList = function() {
  return /** @type {!Array<!proto.flight_connect.ConnectionState.Enum>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.flight_connect.ConnectionState.Enum>} value
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.setConnectionStatesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.flight_connect.ConnectionState.Enum} value
 * @param {number=} opt_index
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.addConnectionStates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.clearConnectionStatesList = function() {
  return this.setConnectionStatesList([]);
};


/**
 * optional DeviceClientStats client_stats = 4;
 * @return {?proto.skygateway.DeviceClientStats}
 */
proto.skygateway.AggregateDeviceStats.prototype.getClientStats = function() {
  return /** @type{?proto.skygateway.DeviceClientStats} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.DeviceClientStats, 4));
};


/**
 * @param {?proto.skygateway.DeviceClientStats|undefined} value
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
*/
proto.skygateway.AggregateDeviceStats.prototype.setClientStats = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.clearClientStats = function() {
  return this.setClientStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.AggregateDeviceStats.prototype.hasClientStats = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DeviceTunnelStats tunnel_stats = 5;
 * @return {?proto.skygateway.DeviceTunnelStats}
 */
proto.skygateway.AggregateDeviceStats.prototype.getTunnelStats = function() {
  return /** @type{?proto.skygateway.DeviceTunnelStats} */ (
    jspb.Message.getWrapperField(this, proto.skygateway.DeviceTunnelStats, 5));
};


/**
 * @param {?proto.skygateway.DeviceTunnelStats|undefined} value
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
*/
proto.skygateway.AggregateDeviceStats.prototype.setTunnelStats = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.clearTunnelStats = function() {
  return this.setTunnelStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skygateway.AggregateDeviceStats.prototype.hasTunnelStats = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint32 sample_count = 6;
 * @return {number}
 */
proto.skygateway.AggregateDeviceStats.prototype.getSampleCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.skygateway.AggregateDeviceStats} returns this
 */
proto.skygateway.AggregateDeviceStats.prototype.setSampleCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skygateway.DeviceHeartbeat.prototype.toObject = function(opt_includeInstance) {
  return proto.skygateway.DeviceHeartbeat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skygateway.DeviceHeartbeat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DeviceHeartbeat.toObject = function(includeInstance, msg) {
  var f, obj = {
organizationName: jspb.Message.getFieldWithDefault(msg, 1, ""),
organizationDataLevel: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skygateway.DeviceHeartbeat}
 */
proto.skygateway.DeviceHeartbeat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skygateway.DeviceHeartbeat;
  return proto.skygateway.DeviceHeartbeat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skygateway.DeviceHeartbeat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skygateway.DeviceHeartbeat}
 */
proto.skygateway.DeviceHeartbeat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOrganizationName(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud_api.DataLevel.LevelEnum} */ (reader.readEnum());
      msg.setOrganizationDataLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skygateway.DeviceHeartbeat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skygateway.DeviceHeartbeat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skygateway.DeviceHeartbeat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skygateway.DeviceHeartbeat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrganizationDataLevel();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string organization_name = 1;
 * @return {string}
 */
proto.skygateway.DeviceHeartbeat.prototype.getOrganizationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skygateway.DeviceHeartbeat} returns this
 */
proto.skygateway.DeviceHeartbeat.prototype.setOrganizationName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional cloud_api.DataLevel.LevelEnum organization_data_level = 2;
 * @return {!proto.cloud_api.DataLevel.LevelEnum}
 */
proto.skygateway.DeviceHeartbeat.prototype.getOrganizationDataLevel = function() {
  return /** @type {!proto.cloud_api.DataLevel.LevelEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud_api.DataLevel.LevelEnum} value
 * @return {!proto.skygateway.DeviceHeartbeat} returns this
 */
proto.skygateway.DeviceHeartbeat.prototype.setOrganizationDataLevel = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.skygateway);
